import React from 'react';
import Section from './Section';

const HowItWorks = () => {
  const steps = [
    {
      num: "01",
      title: "Submit your apps",
      desc: "Tell us the apps you use most on a daily basis. No downloads or invasive access required."
    },
    {
      num: "02",
      title: "We analyze your exposure",
      desc: "We review real data practices, privacy policies, and known risk scenarios associated with your stack."
    },
    {
      num: "03",
      title: "Get your report",
      desc: "Receive a clear, actionable audit within 48 hours detailing your risks and how to secure them."
    }
  ];

  return (
    <Section id="how-it-works">
      <div className="mb-16 md:text-center">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4 text-zinc-950">
          How It Works
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        {steps.map((step, idx) => (
          <div key={idx} className="relative pt-6">
            <div className="absolute top-0 left-0 text-7xl font-black text-zinc-100 -z-10 select-none">
              {step.num}
            </div>
            <h3 className="text-2xl font-bold text-zinc-900 mb-3">{step.title}</h3>
            <p className="text-zinc-600 leading-relaxed">{step.desc}</p>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default HowItWorks;